import { MY_PROGRAMS } from '../ids';
import { InstallLocation } from '../types';
export const ids = MY_PROGRAMS;
export const getDefinition = (staticsUrl, t) => ({
    ...ids,
    installLocation: InstallLocation.Standalone,
    showInLoginMenu: true,
    showInMemberMenu: true,
    social: false,
    socialHome: false,
    method: 'addSection',
    menuOrder: 2,
    urlOverride: 'challenges',
    page: {
        name: t('members-area.challenges.name'),
        shortDescription: t('members-area.challenges.short-description'),
        description: t('members-area.challenges.description'),
        origin: t('members-area.challenges.origin'),
        iconURL: `${staticsUrl}assets/images/icons/challenges-icon.png`,
        screenshots: [
            `${staticsUrl}assets/images/my-challenges/my-challenges.png`,
            `${staticsUrl}assets/images/my-challenges/my-challenges-2.png`,
            `${staticsUrl}assets/images/my-challenges/mobile-my-challenges.png`,
        ],
    },
});
//# sourceMappingURL=my-programs.js.map